import MenuIntroCard from './MenuIntroCard'

export default MenuIntroCard
